module.exports = __webpack_public_path__ + "img/5-3.4912e71d.svg";